// ** React Imports
import { Suspense, useContext, lazy } from 'react';

// ** Utils
import { AbilityContext } from '../utility/context/Can';

// ** Custom Components

// ** Router Components
import {
    BrowserRouter as AppRouter,
    Route,
    Switch,
    Redirect,
} from 'react-router-dom';

import { useSelector } from 'react-redux';

// ** Routes & Default Routes
import { DefaultRoute, Routes } from './routes';

// ** Layouts
import BlankLayout from '../layouts/AnonymousLayout';
import LoggedLayout from '../layouts/LoggedLayout';
// import ElcLayout from '../layouts/ElcLayout';

import { getAuth } from '../redux/selectors';

const Router = () => {
    const auth = useSelector(getAuth);

    // ** ACL Ability Context
    const ability = useContext(AbilityContext);

    // ** Default Layout
    const DefaultLayout = 'LoggedLayout';

    // ** All of the available layouts
    const Layouts = { BlankLayout, LoggedLayout };

    // ** Current Active Item
    const currentActiveItem = null;

    // ** Return Filtered Array of Routes & Paths
    // const LayoutRoutesAndPaths = (layout) => {
    //     const LayoutRoutes = [];
    //     const LayoutPaths = [];

    //     if (Routes) {
    //         Routes.filter((route) => {
    //             // ** Checks if Route layout or Default layout matches current layout
    //             if (
    //                 route.layout === layout ||
    //                 (route.layout === undefined && DefaultLayout === layout)
    //             ) {
    //                 LayoutRoutes.push(route);
    //                 LayoutPaths.push(route.path);
    //             }
    //         });
    //     }

    //     return { LayoutRoutes, LayoutPaths };
    // };

    const NotAuthorized = lazy(() => import('../pages/Misc/NotAuthorized'));

    // const HomePage = lazy(() => import('../pages/HomePage'));

    // ** Init Error Component
    const Error = lazy(() => import('../pages/Misc/Error'));

    /**
     ** Final Route Component Checks for Login & User Role and then redirects to the route
     */
    const FinalRoute = (props) => {
        // console.log(props);
        const route = props.route;
        let action, resource;
        const redirectUrl = new URLSearchParams(props.location.search);

        // ** Assign vars based on route meta
        if (route.meta) {
            action = route.meta.action ? route.meta.action : null;
            resource = route.meta.resource ? route.meta.resource : null;
        }

        if (
            (!auth.loggedIn && route.meta === undefined) ||
            (!auth.loggedIn &&
                route.meta &&
                !route.meta.authRoute &&
                !route.meta.publicRoute)
        ) {
            /**
             ** If user is not Logged in & route meta is undefined
             ** OR
             ** If user is not Logged in & route.meta.authRoute, !route.meta.publicRoute are undefined
             ** Then redirect user to login
             */

            return (
                <Redirect
                    to={
                        route?.meta?.addToLoginReditect
                            ? `/login?redirectUrl=${props.location.pathname}${props.location.search}`
                            : '/login'
                    }
                />
            );
        } else if (route.meta && route.meta.authRoute && auth.loggedIn) {
            // ** If route has meta and authRole and user is Logged in then redirect user to home page (DefaultRoute)
            return <Redirect to={redirectUrl.get('redirectUrl') || '/'} />;
        } else if (auth.loggedIn && !ability.can(action || 'read', resource)) {
            console.log('redirect', action, resource);
            // ** If user is Logged in and doesn't have ability to visit the page redirect the user to Not Authorized
            return <Redirect to="/misc/not-authorized" />;
        } else {
            // ** If none of the above render component
            return <route.component {...props} />;
        }
    };

    const defaultRoute = DefaultRoute(
        auth?.loggedUser?.roles || [],
        auth?.loggedUser?.source || [],
        auth?.loggedUser?.userDetail?.lastReferralId || null,
    );

    // ** Return Route to Render
    const ResolveRoutes = () => {
        return Routes.map((route) => {
            let LayoutTag;
            if (route?.layout === 'auto') {
                let layout = auth.loggedIn ? DefaultLayout : 'BlankLayout';
                LayoutTag = Layouts[layout];
            } else {
                LayoutTag = Layouts[route?.layout || DefaultLayout];
            }

            return (
                <Route
                    key={route.path}
                    path={route.path}
                    exact={route.exact === true}
                    render={(props) => {
                        return (
                            <LayoutTag
                                {...props}
                                {...route}
                                currentActiveItem={currentActiveItem}
                                roles={auth?.loggedUser?.roles || null}
                            >
                                <Suspense fallback={null}>
                                    <FinalRoute route={route} {...props} />
                                </Suspense>
                            </LayoutTag>
                        );
                    }}
                />
            );
        });
    };

    return (
        <AppRouter basename="">
            <Switch>
                {/* If user is logged in Redirect user to DefaultRoute else to login */}
                <Route
                    exact
                    path="/"
                    render={() => {
                        return auth.loggedIn ? (
                            <Redirect
                                to={{
                                    pathname: defaultRoute,
                                    state: 'check',
                                }}
                            />
                        ) : (
                            // <Layouts.BlankLayout showNavbar={true}>
                            //     <HomePage />
                            // </Layouts.BlankLayout>
                            <Redirect to="/login" />
                        );
                    }}
                />
                {/* Not Auth Route */}
                <Route
                    exact
                    path="/misc/not-authorized"
                    render={() => (
                        <Layouts.BlankLayout>
                            <NotAuthorized />
                        </Layouts.BlankLayout>
                    )}
                />
                {ResolveRoutes()}

                {/* NotFound Error page */}
                <Route path="*" component={Error} />
            </Switch>
        </AppRouter>
    );
};

export default Router;
